var render = function render(){var _vm=this,_c=_vm._self._c;return _c('b-form-checkbox-group',{staticClass:"checkBoxGroup",attrs:{"id":_vm.field.id,"options":_vm.field.options,"value-field":_vm.field.valueField,"text-field":_vm.field.textField,"disabled":_vm.field.disabled},on:{"change":_vm.changed},model:{value:(_vm.proxyValue),callback:function ($$v) {_vm.proxyValue=$$v},expression:"proxyValue"}})
}
var staticRenderFns = []

export { render, staticRenderFns }